// src/components/CartPage.jsx
import React, { useEffect, useState, useRef } from 'react';
import { getCart, removeCartItem } from '../api/commerce';
import { useAuth, loading } from '../utils/AuthContext';
import { useNavigate, useLocation, Link} from 'react-router-dom';
import { useParams } from "react-router-dom";
import Loading from '../components/loading/Loading';
import NavbarLog from '../components/NavbarLog';
import Footer from '../components/Footer';
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import jalaliday from "jalaliday";
import "dayjs/locale/fa";
import '../css/CartPage.css';


const CartPage = () => {
  const [carts, setCarts] = useState([]);
  const { user, loading, isAuthenticated} = useAuth();
  const { lang } = useParams();
  const [setlang, setLang] = useState("fa")
  const [consoleError, setConsoleError] = useState("");
  const summaryRef = useRef(null);
  const rafRef = useRef(null);
  const location = useLocation();
  const navigate = useNavigate();

  const fetchCart = async () => {
    try {
      const response = await getCart();
      const cartsData = Array.isArray(response) ? response : response.data;
      setCarts(cartsData);
    } catch (error) {
      setConsoleError("Error loading cart:", error);
    }
  };

  useEffect(() => {
    if (isAuthenticated) {
      fetchCart();
    }
  }, [isAuthenticated]); 

  useEffect(() => {
    if (!loading) {
      if (!user) {
        navigate(`/${lang}/login`, { state: { from: location }, replace: true });
      }
    }
  }, [user, loading, navigate, location]);

  const removeItem = (id) => {
    removeCartItem(id);
    const fetchCart = async () => {
      try {
        const response = await getCart();
        const cartsData = Array.isArray(response) ? response : response.data;

        setCarts(cartsData);
        fetchCart();
        window.location.reload();

      } catch (err) {
        setConsoleError(err);
        setCarts([]);
      } finally {
      }
  };
  fetchCart();
  };

  useEffect(() => {
    const el = summaryRef.current;
    if (!el) return;

    // Motion configuration
    const multiplier = 0.18;    
    const maxTranslate = 80;    
    const minTranslate = -40;  

    let lastScroll = 0;

    function onScroll() {
      lastScroll = window.scrollY;
      if (rafRef.current) return;
      rafRef.current = requestAnimationFrame(() => {
        const t = Math.max(minTranslate, Math.min(maxTranslate, lastScroll * multiplier));
        el.style.transform = `translateX(${t}px)`;
        rafRef.current = null;
      });
    }

    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();

    return () => {
      window.removeEventListener("scroll", onScroll);
      if (rafRef.current) cancelAnimationFrame(rafRef.current);
    };
  }, []);
  

  // Transation
  dayjs.extend(utc);
  dayjs.extend(jalaliday);
  const toPersiDigits = (str) =>
    str.replace(/\d/g, (d) => "۰۱۲۳۴۵۶۷۸۹"[d]);

  useEffect (() => {
    const userTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    if(lang !== "fa" && lang !== "en") {
      if ( userTimezone === "Asia/Tehran") {
        setLang(`fa`);
      } else {
        setLang(`en`);
      }
    } else {
      setLang(lang)
    }
  }, [lang])
  

  if (loading) return <Loading />;
  if (!carts || !carts.length) 
    return (
      <>
        <NavbarLog />
        <div className="cart-page">
          {setlang === "en" ? 
          <p>Cart is empty</p>:
          <p>سبد خرید شما خالی است</p>
          }
        </div>
        <Footer />
      </>
    );

  return (
    <>
      <NavbarLog />
      <div className="cart-page">
        <main className="cart-grid">
          {/* Left: Items column */}
          <section className="cart-items">
            <header className="cart-header">
              <h1>{setlang === "en" ? "Your Cart" :"سبد خرید" }</h1>
              <p className="muted">{setlang === "en" ? "Your cart items to review" : "آیتم‌های موجود در سبد خرید شما" }</p>
            </header>
            <div className="items-list">
              {carts.map(cart => (
                <div key={cart.id}>
                  {(cart.items || []).length === 0 ? (
                    <div className="empty">{setlang === "en" ? "..." : "..." }</div>
                  ) : (
                    cart.items.map(item => (
                      <div className="ci-card" key={item.id}>
                        <div className="ci-imags">
                          {Array.isArray(item.product.images) && item.product.images.length > 0 &&
                            item.product.images.map(img => (
                                <img key={img.id}
                                  className="ci-image"
                                  src={img.image}
                                  alt={img.id}
                                />
                            ))
                          }
                          {Array.isArray(item.product.images) && item.product.images.length == 0 &&
                          <p>{setlang === "en" ? "No image available" : "عکسی موجود نیست" }</p>
                          }
                        </div>

                        {/* Product Details */}
                        <div className="ci-body">
                          {setlang === "en" ?
                          <h3 id={`product-${item.id}`} className="ci-title">{item.product?.name ?? "Unnamed Product"}</h3>
                          :
                          <h3 id={`product-${item.id}`} className="ci-title">{item.product?.name ?? "''"}</h3>
                          }

                          {setlang === "en" ?
                          <p className="ci-meta">{item.product?.description ? item.product.description.slice(0, 60) : "No description available"}</p>
                          :
                          <p className="ci-meta">{item.product?.description ? item.product.description.slice(0, 60) : "''"}</p>
                          }

                          {setlang === "en" ?
                          <p className="ci-meta"> By: {item.product?.artist ? item.product.artist.slice(0, 60) : "unknown"}</p>
                          :
                          <p className="ci-meta"> اثر: {item.product?.artist ? item.product.artist.slice(0, 60) : "ناشناس"}</p>
                          }

                          <div className="ci-bottom">
                            {setlang === "en" ?
                            <div className="ci-price"> IRT {new Number(item.subtotal).toLocaleString()}</div>:
                            <div className="ci-price">{toPersiDigits(new Number(item.subtotal).toLocaleString())} تومان</div>
                            }
                          </div>

                          {/* Actions */}
                          <button type="button" className="ci-remove" onClick={() => removeItem(item.id)}>
                            {setlang === "en" ? "Remove" : "حذف از سبد خرید" }
                          </button>
                        </div>
                      </div>
                    ))
                  )}
                </div>
              ))}
            </div>

            <div className="cart-footer-note">
              {setlang === "en" ?
              <small>Delivery and taxes are calculated at checkout</small>:
              <small> هزینه‌های پستی و مالیات در مرحله‌ی ثبت سفارش </small>
              }
            </div>
          </section>

          {/* Right: Summary */}
          <aside className="cart-summary" ref={summaryRef}>
            <div className="summary-card">
              <h2>{setlang === "en" ? "Order Summary" : "مبلغ سبد خرید" }</h2>
              {carts.map(cart => (
                
                <div key={cart.id}>
                  {setlang === "en" ?
                  <div className="summary-row">
                    <span>Subtotal</span>
                    <strong>IRT {new Number(cart.subtotal).toLocaleString()}</strong>
                  </div> :
                  <div className="summary-row">
                    <strong><small> تومان</small> {toPersiDigits(new Number(cart.subtotal).toLocaleString())}</strong>
                    <span>جمع کالاها</span>
                  </div>
                  }

                  {setlang === "en" ?
                  <div className="summary-row muted">
                    <span>Shipping</span>
                    <span>Calculated at checkout</span>
                  </div> :
                  <div className="summary-row muted">
                    <span>در مرحله ثبت سفارش</span>
                    <span>ارسال پستی</span>
                  </div>
                  }

                  {setlang === "en" ?
                  <div className="summary-row muted">
                    <span>Tax</span>
                    <span>Calculated at checkout</span>
                  </div> :
                  <div className="summary-row muted">
                    <span>در مرحله ثبت سفارش</span>
                    <span>مالیات</span>
                  </div>
                  }

                  <div className="summary-total">
                    {setlang === "en" ? (
                      <>
                      <span><big>Total</big></span>
                      <span className="total-amount"><big>IRT {new Number(cart.total).toLocaleString()}</big></span>
                      </>
                    ):(
                      <>
                      <span className="total-amount"><small>تومان</small><big> {toPersiDigits(new Number(cart.total).toLocaleString())}</big></span>
                      <span> <big> جمع کل</big></span>
                      </>
                    )}
                  </div>
                  {(cart.items || []).length !== 0 ? (

                    <div className='btn-action'>
                    <Link to= {`/${setlang}/gallery`}>
                      <button className="btn-secondary"> {setlang === "en" ? "Continue Shopping" : "اضافه کردن به سبد خرید" } </button>
                    </Link>
                    <Link to= {`/${setlang}/checkout`} state= {{ cartId: cart.id }}>
                      <button className="btn-primary" type="button">{setlang === "en" ? "Proceed to checkout" : "ثبت سفارش" }</button>
                    </Link> 
                  </div>
                  ):(null)}
                </div>
              ))}
            </div>
          </aside>
        </main>
      </div>

      <Footer />
    </>

  );
};

export default CartPage;